class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      let localStorage_state = localStorage.getItem('user_location')?.toLowerCase();
      if (localStorage_state == 'ca') {
        document.querySelectorAll('[data-non-thc-url]').forEach((ele)=>{
          ele.setAttribute('data-url',ele.getAttribute('data-non-thc-url'));
        });
      }
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim()) {
              this.innerHTML = recommendations.innerHTML;
              if(this.dataset.url.indexOf('intent=complementary') > -1){
              
              const complementaryParent = document.querySelector('[data-complementaryitems]');
              complementaryParent?.classList.remove('d-none');
            }

            let quickShopModal = document.querySelector('quick-shop');
            if(quickShopModal && typeof quickShopModal.updateEvents == 'function') quickShopModal.updateEvents();
            manage_california_products();
            let types = [];
            this.querySelectorAll('[data-product-effect]').forEach(ele => {
              types.push(ele.getAttribute('data-product-effect'));
            });

            this.querySelectorAll('[data-product-filter]').forEach((ele)=> {
              const effect = ele.getAttribute('data-product-filter');
              if (types.includes(effect) || effect == 'all') {
                ele?.classList.remove('d-none');
              }else {
                ele?.classList.add('d-none');
              }
              ele.addEventListener('click',(event) => {
                event.preventDefault();
                this.querySelectorAll('[data-product-filter].active').forEach((filterEle)=>{
                  filterEle?.classList.remove('active');
                });
                ele?.classList.add('active');
                this.querySelectorAll('[data-product-effect]').forEach((ele) => {
                  ele?.classList.add('swiper-slider-hidden');
                  ele?.classList.remove('swiper-slide');

                });
                
                if (effect == 'all') {
                  this.querySelectorAll('[data-product-effect]').forEach((ele) => {
                    ele?.classList.remove('swiper-slider-hidden');
                    ele?.classList.add('swiper-slide');
                  });
                }else {
                  this.querySelectorAll(`[data-product-effect="${effect}"]`).forEach((ele) => {
                    ele?.classList.remove('swiper-slider-hidden');
                    ele?.classList.add('swiper-slide');
                  });
                }
                this.querySelector('slider-element')?.reInitSlider();
              })
            });
            if(this.querySelectorAll('[data-product-filter]:not(.d-none)')?.length == 1) {
              this.querySelector('[data-effect-filters]')?.classList.add('d-none');
              this.querySelector('[data-effect-filters-heading]')?.classList.add('d-none');
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
}
customElements.define('product-recommendations', ProductRecommendations);